module.exports = __webpack_public_path__ + "img/icon-chat-success.aed80fd0.svg";